import React from 'react';
import RiskStatAnalysisComponent from "./RiskStatAnalysisComponent";
import {ReportSectionHeader} from "../SectionHeader";
import {dollarFormatWithCommas} from "../../../util";


const formatRiskStats = (riskStats) => {
	let dataObj = [];
	if(riskStats.length) {

		dataObj[0] = {
			"axis": "High Risk-( " + Math.ceil(Math.max(riskStats[0]['aceHighRisk'], riskStats[1]['aceHighRisk'])).toString()+" )",
			"Industry" : riskStats[0]['aceHighRisk']/Math.ceil(Math.max(riskStats[0]['aceHighRisk'], riskStats[1]['aceHighRisk'])),
			"Company" : riskStats[1]['aceHighRisk']/Math.ceil(Math.max(riskStats[0]['aceHighRisk'], riskStats[1]['aceHighRisk'])),
			"fullMark" : Math.ceil(Math.max(riskStats[0]['aceHighRisk'], riskStats[1]['aceHighRisk']))
		};
		dataObj[1] = {
			"axis": "Type II-( " + Math.ceil(Math.max(riskStats[0]['aceType2'], riskStats[1]['aceType2'])).toString()+" )",
			"Industry" : riskStats[0]['aceType2']/Math.ceil(Math.max(riskStats[0]['aceType2'], riskStats[1]['aceType2'])),
			"Company" : riskStats[1]['aceType2']/Math.ceil(Math.max(riskStats[0]['aceType2'], riskStats[1]['aceType2'])),
			"fullMark" : Math.ceil(Math.max(riskStats[0]['aceType2'], riskStats[1]['aceType2']))
		};
		dataObj[2] = {
			"axis": "Market Cap. (M)-" + dollarFormatWithCommas(Math.max(parseInt(riskStats[0]['marketCapitalization']/1000000, 10), parseInt(riskStats[1]['marketCapitalization']/1000000, 10))),
			"Industry" : parseInt(riskStats[0]['marketCapitalization']/1000000, 10)/Math.max(parseInt(riskStats[0]['marketCapitalization']/1000000, 10), parseInt(riskStats[1]['marketCapitalization']/1000000, 10)),
			"Company" : parseInt(riskStats[1]['marketCapitalization']/1000000, 10)/Math.max(parseInt(riskStats[0]['marketCapitalization']/1000000, 10), parseInt(riskStats[1]['marketCapitalization']/1000000, 10)),
			"fullMark" : Math.max(parseInt(riskStats[0]['marketCapitalization']/1000000, 10), parseInt(riskStats[1]['marketCapitalization']/1000000, 10))
		};
		dataObj[3] = {
			"axis": "Market Cap. Loss (M)-" + dollarFormatWithCommas(Math.max(parseInt(riskStats[0]['marketCapitalizationLoss']/1000000, 10), parseInt(riskStats[1]['marketCapitalizationLoss']/1000000, 10))),
			"Industry" : parseInt(riskStats[0]['marketCapitalizationLoss']/1000000, 10)/Math.max(parseInt(riskStats[0]['marketCapitalizationLoss']/1000000, 10), parseInt(riskStats[1]['marketCapitalizationLoss']/1000000, 10)),
			"Company" : parseInt(riskStats[1]['marketCapitalizationLoss']/1000000, 10)/Math.max(parseInt(riskStats[0]['marketCapitalizationLoss']/1000000, 10), parseInt(riskStats[1]['marketCapitalizationLoss']/1000000, 10)),
			"fullMark" : Math.max(parseInt(riskStats[0]['marketCapitalizationLoss']/1000000, 10), parseInt(riskStats[1]['marketCapitalizationLoss']/1000000, 10))
		};
		dataObj[4] = {
			"axis": "Type I-( " + Math.ceil(Math.max(riskStats[0]['aceType1'], riskStats[1]['aceType1'])).toString()+" )",
			"Industry" : riskStats[0]['aceType1']/Math.ceil(Math.max(riskStats[0]['aceType1'], riskStats[1]['aceType1'])),
			"Company" : riskStats[1]['aceType1']/Math.ceil(Math.max(riskStats[0]['aceType1'], riskStats[1]['aceType1'])),
			"fullMark" : Math.ceil(Math.max(riskStats[0]['aceType1'], riskStats[1]['aceType1']))
		};
	}
	
	return dataObj;
};


const RiskStatAnalysisContainer = (props) => {

	if (!props.riskStats) {
		return <div>Loading</div>
	}
	//console.log("Here!");
	let myColor = "#FFFFFF"
	let myIndustryName = "Sector"
	let myCompanyName = "Company"

	if(props.riskStats.length) {
		myColor = props.riskStats[0]['sectorColor']
		myIndustryName = props.riskStats[0]['sectorName']
		myCompanyName = props.riskStats[1]['sectorName']
	}

	let data = formatRiskStats(props.riskStats);
	//console.log(data);

	return (
		<React.Fragment>
			<ReportSectionHeader style={{paddingLeft:'40px'}}>SAR Risk Profile </ReportSectionHeader>
			
			<RiskStatAnalysisComponent graphData={data} claimTypeId={props.claimTypeId} sectorColor={myColor} industry={myIndustryName} company={myCompanyName} />
		</React.Fragment>
	);

};


export default RiskStatAnalysisContainer;


// WEBPACK FOOTER //
// ./src/common/components/RiskStatAnalysis/RiskStatAnalysisContainer.js